function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { Button } from '@tapresearch/ui/components';
import React, { useContext, useMemo } from 'react';
import { filterContext } from '../FilterProvider';
export function OpenFilterButton(_param) {
    var omitFilters = _param.omitFilters, children = _param.children, rest = _object_without_properties(_param, [
        "omitFilters",
        "children"
    ]);
    var filterValues = useContext(filterContext).filterValues;
    var hasFilters = useMemo(function() {
        var omitFiltersSet = new Set(omitFilters);
        var filterKeys = Object.keys(filterValues).filter(function(k) {
            return !omitFiltersSet.has(k);
        });
        return filterKeys.length > 0;
    }, [
        filterValues,
        omitFilters
    ]);
    return /*#__PURE__*/ React.createElement(Button, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, rest), {
        variant: hasFilters ? 'subtle' : 'outline',
        isActive: hasFilters,
        fontWeight: "bold",
        colorScheme: hasFilters ? 'blue' : 'gray'
    }), !hasFilters && {
        color: 'gray.600',
        borderColor: 'gray.400'
    }), {
        _active: {
            bgColor: hasFilters ? 'blue.100' : undefined,
            _hover: {
                bgColor: hasFilters ? 'blue.300' : 'gray.200'
            }
        },
        _hover: {
            bgColor: 'gray.100'
        }
    }), children);
}
